export default "__VITE_ASSET__DaDo$664__"